export const consumerPartners: string[] = [
  'Acuteresponse',
  'Apple',
  'b.well',
  'Bell Data Systems',
  'BillZero',
  'Coral Health',
  'e7corp',
  'ER Partners',
  'Flagship VA Mobile Application',
  'GeoffreyClapp',
  'GirlsComputingLeague',
  'Hill & Ponton P.A.',
  'Humetrix',
  'ID.me',
  'Know A Vet',
  'Libera',
  'MyPatientLink',
  'OneRecord',
  'Panoramic Software',
  'Roaring Fork Transportation Authority',
  'Santa Clara County VetCheck',
  'Thank You Universe',
  'The Commons Project',
  'Tyler Technologies',
  'USAJOBS',
  'VA.gov',
  'VAClaimHelper',
  'Veteran ID Card',
  'Veterans Information Services',
];
